import React, { useContext } from "react";
import { AppContext } from "@context/AppContext";
import useNavigationData from "@staticQueries/mobileNavigationQuery";
import { Dropdown, NavLink } from "./";
import { Button } from "@ui";
import { twMerge } from "tailwind-merge";
import { KontentButton } from "@components/ui/Button";

const Sidebar = () => {
  const { isSidebarOpen } = useContext(AppContext);
  const data = useNavigationData();

  const renderMainLinks = () =>
    data.main_links.value.map((group, idx: number) => {
      // Check if the group is a dropdown
      if ("title" in group.elements) {
        return (
          <Dropdown title={group.elements.title.value} key={`dropdown-${idx}`}>
            {group.elements.links.value.map((link, linkIdx) => (
              <NavLink
                internalPath={link.elements.internal_path.value}
                externalUrl={link.elements.external_url.value}
                target={link.elements.open_in_new_window.value[0].codename}
                key={`link-${linkIdx}`}
              >
                {link.elements.text.value}
              </NavLink>
            ))}
          </Dropdown>
        );
      } else {
        // It's a simple link
        return (
          <NavLink
            internalPath={group.elements.internal_path.value}
            externalUrl={group.elements.external_url.value}
            target={group.elements.open_in_new_window.value[0].codename}
            boldText
            key={`main-link-${idx}`}
          >
            {group.elements.text.value}
          </NavLink>
        );
      }
    });

  const renderSecondaryLinks = () =>
    data.secondary_links.value.map((link, idx) => {
      // Check if the link is a button
      if ("variant" in link.elements) {
        return (
          <Button {...(link as KontentButton)} key={idx}>
            {link.elements.text.value}
          </Button>
        );
      } else {
        // It's a simple link
        return (
          <NavLink
            internalPath={link.elements.internal_path.value}
            externalUrl={link.elements.external_url.value}
            target={link.elements.open_in_new_window.value[0].codename}
            icon={link.elements.icon?.value[0]}
            boldText
            key={`secondary-link-${idx}`}
          >
            {link.elements.text.value}
          </NavLink>
        );
      }
    });

  return (
    <aside
      className={twMerge(
        "bg-waves fixed top-[68px] z-40 h-[calc(100vh-68px)] w-screen bg-cover transition duration-300",
        !isSidebarOpen && "translate-x-full opacity-0",
      )}
    >
      <nav className="container flex h-full flex-col items-center justify-center gap-10">
        <div className="flex flex-col items-center gap-5">
          {renderMainLinks()}
        </div>
        <div className="flex flex-col items-center gap-5">
          {renderSecondaryLinks()}
        </div>
      </nav>
    </aside>
  );
};

export default Sidebar;
